module.exports = __webpack_public_path__ + "img/upload.b4a93ac7.svg";